<template>
    <v-dialog v-model="show" width="40vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
        <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
            <v-card-title class="text-h5 lighten-2"> Eliminar OP </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <span class="text-subtitle-1" v-if="orderToUpdate">
                                ¿Seguro que quiere eliminar la OP
                                <span class="font-italic font-weight-bold">
                                    "{{ orderToUpdate.serial }}"
                                </span>
                                ?
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn color="red" block @click="closeModal()" dark :disabled="isLoading">Cancelar</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="primary" block @click="confirmation" :loading="isLoading">Eliminar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    data: () => ({
        isLoading: false,
        form: {
            nickname: null,
            address: null,
            phone: null,
            email: null,
            contact: null,
        },
        user: JSON.parse(localStorage.getItem("user")),
    }),
    props: {
        value: Boolean,
    },
    computed: {
        ...mapState("order", ["orderToUpdate"]),
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        ...mapActions("order", ["deleteOrder"]),
        ...mapMutations("order", ["SET_ORDER_TO_UPDATE"]),
        closeModal() {
            this.SET_ORDER_TO_UPDATE(null)
            this.show = false;
        },
        async confirmation() {
            //emit fetch table
            try {
                this.isLoading = true;
                let payload = {
                    orderId: this.orderToUpdate._id,
                };
                await this.deleteOrder(payload);
                this.$swal({
                    icon: "success",
                    title: `OP eliminada`,
                    showConfirmButton: false,
                    timer: 500,
                });
                this.$emit("update");
                this.closeModal()
            } catch (error) {
                console.log(error);
                this.$swal({
                    icon: "error",
                    title: `Algo salio mal al. Error: ${error.message}`,
                    showConfirmButton: false,
                    timer: 2000,
                });
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
